import { SoapLabels } from '@/shared/types/yakurekiSoap'

const domain = window.location.hostname

// 証明書認証が必要なドメインの判定
export const isCertDomain =
  domain === 'cert.kakeru.medilabai.com' || // 本番cert
  domain === 'cert.app.kakeru-staging.com' // Staging cert

export const API_HOST = isCertDomain
  ? import.meta.env.VITE_CERT_API_HOST
  : import.meta.env.VITE_API_HOST

export const serviceName = 'Kakeru君'

export const soapLabels = {
  subjectives: '【S】',
  objectives: '【O】',
  assessments: '【A】',
  educational_plans: '【EP】',
  care_plans: '【CP】',
  observational_plans: '【OP】',
} as SoapLabels

// Special user IDs for custom formatting and features
export const USER_IDS = {
  SPECIAL_FORMAT: '90b029a2-0a18-4f36-a6b7-0fa4750fde52',
}

// Tooltip messages for recording functionality
export const getRecordingTooltipText = (
  isProgress: boolean,
  isNsipsMode: boolean
): string => {
  if (isProgress) {
    return 'SOAP生成中です。しばらくお待ちください'
  }

  // NSIPSモードの場合は「カスタム録音」を表示
  if (isNsipsMode) {
    return 'カスタム録音'
  }

  return '服薬指導を録音(Shift+⏎)'
}

// Recording modal button text functionality (for modal)
export const getRecordingButtonText = (
  isRecording: boolean,
  isNsipsMode: boolean
): string => {
  if (isRecording) {
    return isNsipsMode ? '録音停止' : '録音停止(Shift+⏎)'
  }
  return isNsipsMode ? '録音開始' : '録音開始(Shift+⏎)'
}

// Main screen recording button text functionality (for patient screen)
export const getMainScreenRecordingText = (
  isRecording: boolean,
  isNsipsMode: boolean
): string => {
  if (isRecording) {
    return isNsipsMode ? '録音停止(Shift+⏎)' : '録音停止'
  }
  return isNsipsMode ? '服薬指導を録音(Shift+⏎)' : '服薬指導を録音'
}

// Advanced search related constants
export const ADVANCED_SEARCH = {
  MAX_SEARCH_HISTORY: 10,
  DEFAULT_PAGE_SIZE: 20,
  TABLE_MAX_HEIGHT: 500,
} as const

// Drug selection related constants
export const DRUG_SELECTION = {
  MAX_SELECTION_COUNT: 1000,
} as const
